var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('iframe',{staticClass:"link-frame",class:{'link-frame--partial': _vm.partial},attrs:{"src":_vm.src,"allowfullscreen":"false","allow":"camera; microphone"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }